import { LOCALE_EN_US } from 'src/apps/dashboard/constants/Dashboard';

import { formatDateForTable } from '../../accessibility-trends-chart/helpers/dateFormatHelpers';
import { CHART_TEXT } from '../constants';

/**
 * Formats count values for table display with internationalization
 */
const formatTableCount = (value: string | number): string => {
	const numericValue = typeof value === 'string' ? parseFloat(value) : value;
	if (Number.isNaN(numericValue)) {
		return '0';
	}

	const formatter = new Intl.NumberFormat(LOCALE_EN_US);
	return formatter.format(numericValue);
};

/**
 * Table configuration for critical issues chart
 */
export const TABLE_PROPS = {
	dataType: 'Date' as const,
	columnsPattern: [
		{
			name: CHART_TEXT.TABLE_COLUMNS.DATE,
			field: 'date',
			formatter: formatDateForTable
		},
		{
			name: CHART_TEXT.TABLE_COLUMNS.CRITICAL,
			field: 'criticalSortValue',
			formatter: formatTableCount
		},
		{
			name: CHART_TEXT.TABLE_COLUMNS.SERIOUS,
			field: 'seriousSortValue',
			formatter: formatTableCount
		},
		{
			name: CHART_TEXT.TABLE_COLUMNS.TOTAL,
			field: 'totalSortValue',
			formatter: formatTableCount
		}
	]
};
